module.exports = __webpack_public_path__ + "static/media/half-mirchi.510782a5.svg";